import React from 'react'
import MyTable from '../../UI/table/MyTable'
import { IconButton, TableCell } from '@mui/material'
import MyTableNotFound from '../../UI/table/MyTableNotFound'
import SupplyBillItem from './SupplyBillItem'
import MyTableCheckBoxAll from '../../UI/table/MyTableCheckBoxAll'
import { useDispatch, useSelector } from 'react-redux'
import { setSupplyBillsChecked } from '../../../store/supplyBillSlice'
import MySortHeadField from '../../UI/table/sort/MySortHeadField'
import SupplierSortField from './sort/SupplierSortField'
import IdSortField from './sort/IdSortField'
import { CreatedAtSortField } from './sort/CreatedAtSortField'

const SupplyBillTable = ({ supplyBills, count, offset, setOffset, limit, setLimit, loading }) => {

    const checked = useSelector(state => state.supplyBill.supplyBills.checked)
    const dispatch = useDispatch()

  return (
    <MyTable
        head={
            <>
                {/* <TableCell align="center"></TableCell> */}
                <MyTableCheckBoxAll
                    items={supplyBills}
                    checked={checked}
                    setChecked={e => dispatch(setSupplyBillsChecked(e))}
                />
                <TableCell align="center"></TableCell>
                {/* <TableCell align="center">ID</TableCell> */}
                <IdSortField />
                <TableCell align="center">Статус</TableCell>
                {/* <TableCell align="center">Дата створення</TableCell> */}
                <CreatedAtSortField />
                <TableCell align="center">Відповідальний</TableCell>
                {/* <TableCell align="center">Контрагент</TableCell> */}
                <SupplierSortField />
                {/* <TableCell align="center" className='myTable'>
                    Контрагент
                    <IconButton 
                        size="small" 
                        // onClick={(e) => handleOpenMenu(e, 'name')}
                    >
                        <ArrowDropDownIcon fontSize="small"/>
                    </IconButton>
                </TableCell> */}
                <TableCell align="center">Сума</TableCell>
                <TableCell align="center">Погодження</TableCell>
                <TableCell align="center">Оплата</TableCell>
                <TableCell align="center">Доставка</TableCell>
                <TableCell align="center">Інше</TableCell>
                {/* <TableCell align="center">Дії</TableCell> */}
            </>
        }
        body={
            supplyBills && supplyBills.length > 0 ?
                supplyBills.map(supplyBill => 
                    <SupplyBillItem
                        key={supplyBill.id}
                        supplyBill={supplyBill} 
                    />
                )
            : 
                <MyTableNotFound
                    text='Рахунків не знайдено' 
                    // columns={6}
                />
        }
        name='рахунків'
        count={count}
        limit={limit}
        setLimit={setLimit}
        offset={offset}
        setOffset={setOffset}
        loading={loading}
    />
  )
}

export default SupplyBillTable